import React,{Component} from "react";
import Modal from "react-bootstrap/Modal";
import modallogo from "./images/loader.gif";

class BusyModal extends Component{
    constructor(props){
        super(props);
        this.state={isOpen:true}
    }
render(){
    return(
        <div>
        <Modal show={this.state.isOpen}  animation="false" centered backdrop="static" size="sm">
        <Modal.Body><img src={modallogo} style={{width:"50px",height:"30px",paddingRight:"15px"}}/><span style={{PaddingLeft:"15px"}}>Please wait...</span></Modal.Body>
        </Modal>
        </div>
    );
}
}
export default BusyModal;